import React from "react";
import { Menu } from "@mui/material";
import { SMenuPaper, SMenuList } from "./CustomContextMenuStyles";

interface ICustomContextMenu {
  anchorEl: HTMLElement | null;
  children: React.JSX.Element | React.JSX.Element[];
  onClose: () => void;
  dataTestid?: string;
  parentRef?: HTMLElement | null;
  className?: string;
}

export const CustomContextMenu = ({
  anchorEl,
  parentRef,
  children,
  dataTestid = "contextMenu/menu",
  onClose,
  className = "",
}: ICustomContextMenu) => {
  return (
    <Menu
      anchorOrigin={{
        vertical: parentRef ? "bottom" : "top",
        horizontal: parentRef ? "left" : "right",
      }}
      className={className}
      anchorEl={anchorEl}
      data-testid={dataTestid}
      open={Boolean(anchorEl)}
      onClose={onClose}
      slotProps={{
        paper: SMenuPaper,
        list: SMenuList,
      }}
    >
      {children}
    </Menu>
  );
};
